var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 29,
  height: 29,
  viewBox: "0 0 29 29"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-download",
  "data-name": "Icon feather-download",
  transform: "translate(-3.5 -3.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_146",
  "data-name": "Path 146",
  d: "M31.5,22.5v6a3,3,0,0,1-3,3H7.5a3,3,0,0,1-3-3v-6",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_147",
  "data-name": "Path 147",
  d: "M10.5,15,18,22.5,25.5,15",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_148",
  "data-name": "Path 148",
  d: "M18,22.5V4.5",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}))));
export default __webpack_public_path__ + "static/media/download_sidebar.cfa37875.svg";
export { SvgComponent as ReactComponent };